import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Row, Col, Icon, Popconfirm, Button, Popover, Tooltip, Modal } from "../../common/UIComponents";
import OptingAppointment from "./OptingAppointment";
import { checkServiceExistance, isProdEnvironment, renderAlertMessage } from "../../helpers/common";
import PrintLabels from "./PrintLabels";
import CloneOrders from "./CloneOrders";
import { withRouter } from "react-router";
import { WarehouseContext } from "../../context/WarehouseContext";
import { OrgContext } from "../../context/OrgContext";
import BulkLinehaulForm from "./BulkLinehaulForm";
import I18n from "../../common/I18n";
import SwitchOrder from "./SwitchOrder";
import FsuUpdateStatus from "./FsuUpdateStatus";
import AssignOrders from "./AssignOrders";
import { OrderConfigContext } from "../../context/OrderConfigContext";
//import { validateBulkActions } from "./helpers";
import SelectedOrdersList from "./SelectedOrdersList";
import { isLegLevelAssignEnabled } from "./helpers";
import { hasQuickDispatchAssignableLegs, orderHasLegAwaitingAssignment, isLtlOrganization } from "../../helpers/orders";
import { clearAGGridCells } from "../../helpers/ag_grid_functions";
import { AssignIcon, ExcelIcon, RocketIcon, TenderIcon } from "../../common/CustomIcon";
import TenderOrdersModal from "./tenders/TenderOrdersModal";
import { downloadConsolidatedBols, moveOrdersToNewFromPending, uploadCustomsClearanceFile } from "../../api/OrdersApi";
import { alertMessage, base64ToPdf, isEmpty } from "../../common/Common";
import { Select, DatePicker, Upload, message, Input } from "antd";
import moment from "moment";
import { RejectedReasonApi } from "../../api/RejectedReason";
import BaseModal from "../BaseModal";
import ReasonWindow from "../common/ReasonWindow";

const CUSTOMS_DOC_TYPES = [
  { code: "DELIVERY_ORDER", label: "delivery order" },
  { code: "CUSTOMS_RELEASE_DOCUMENT", label: "customs release document" },
  { code: "COPY_OF_CHECK_ACH_NUMBER", label: "copy of check" },
  { code: "CUSTOMS_STATUS_LOG", label: "customs status log (from descartes)" },
  { code: "MAWB_HAWB", label: "MAWB/HAWB" },
  { code: "CARGO_MANIFEST", label: "cargo manifest" }
];

const OrderBulkOperationContainer = React.memo((props) => {
  const {
    handleBolDownload,
    handleCancel,
    selectedOrders,
    resetOrders,
    filter,
    warehouseFilter,
    organizationSettings,
    handleMultipleOrdersStatusChange,
    handleReceiveToConfirm,
    changeStatus,
    statusChangeModal,
    handleEditOrder,
    handleBarCodePrint,
    handleBolClicked,
    showBarCodeModal,
    creditsExceededAccnts,
    getOrders,
    setConfirmBulkDelete,
    setChangeDispatchStatus,
    confirmBulkDelete,
    handleExportToExcel,
    isModalVisible,
    loading: isLoading,
    refreshCallback,
    userContext,
    currentOrg, currentGridRef,
    enableLoading
  } = props;
  const {currentUser, updateScreenConfig} = userContext;
  const { getWHDetails  } = warehouseFilter
  const [hoveredCol, setHoveredCol] = useState(null);
  const [isChildContainerClicked, setIsChildContainerClicked] = useState(false);
  const [isPrintLabelClicked, setIsPrintLabelClicked] = useState(false);
  const [isCloneClicked, setIsCloneClicked] = useState(false);
  const [isChangeStatusClicked, setIsChangeStatusClicked] = useState(false);
  const [isBarcodeClicked, setIsBarcodeClicked] = useState(false);
  const [isBolClicked, setIsBolClicked] = useState(false);
  const [isLinehaulClicked, setIsLinehaulClicked] = useState(false);
  const [isSwitchOrderClicked, setIsSwitchOrderClicked] = useState(false);
  const [isFsuUpdateClicked, setIsFsuUpdateClicked] = useState(false);
  const [isAssignClicked, setIsAssignClicked] = useState(false);
  const [isTenderClicked, setIsTenderClicked] = useState(false);
  const [isExportClicked, setIsExportClicked] = useState(false);
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [rejectionCode, setRejectionCode] = useState('NONE');
  const [rejectionReason, setRejectionReason] = useState('');
  const [approvalRejections, setApprovalRejections] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [errorOrders, setErrorOrders] = useState([]);
  const isProdEnv = isProdEnvironment();
  const currentWh = getWHDetails()
  const { orderSelectedInfo, 
    setOrderSelectedInfo , statusForActions = {} } = useContext(OrderConfigContext)
  const showAssignIcon  = organizationSettings?.quick_dispatch_setting === "true" ? true : false;
  // Load Tendering (agent tenders) — gated on the same org setting the
  // Order-Details tender buttons and backend get_tender_config use
  const showTenderAction = organizationSettings?.agent_load_tender === "true";
  const selectedKeys = orderSelectedInfo.map(order => order.id)
  const handleClick = () => {
    setIsChildContainerClicked(true);
  };
  const [isBulkCustomsClearanceModalVisible, setIsBulkCustomsClearanceModalVisible] = useState(false);
  const [bulkCustomClearanceDate, setBulkCustomClearanceDate] = useState(null);
  const [bulkCustomClearanceFilesMap, setBulkCustomClearanceFilesMap] = useState({});
  const [bulkCustomClearanceFilesUploadedMap, setBulkCustomClearanceFilesUploadedMap] = useState({});
  const [isSavingBulkCustoms, setIsSavingBulkCustoms] = useState(false);
  const [isUploadingAll, setIsUploadingAll] = useState(false);
  const [docPreviewVisible, setDocPreviewVisible] = useState(false);
  const [docPreviewUrl, setDocPreviewUrl] = useState(null);
  const [docPreviewType, setDocPreviewType] = useState(null);

  const IsLinehaulLegacy = organizationSettings && _.get(organizationSettings, "enable_linehaul_plus","false") == "false" ? true : false;

  const handleBulkFileSelect = (file, docTypeCode) => {
    setBulkCustomClearanceFilesMap((prev) => ({
      ...prev,
      [docTypeCode]: file,
    }));
  };

  const handleBulkRemoveFile = (docTypeCode) => {
    setBulkCustomClearanceFilesMap((prev) => {
      const copy = { ...prev };
      delete copy[docTypeCode];
      return copy;
    });
    setBulkCustomClearanceFilesUploadedMap((prev) => {
      const copy = { ...prev };
      delete copy[docTypeCode];
      return copy;
    });
  };

  const handleUploadAllCustomsFiles = () => {
    const filesToUpload = CUSTOMS_DOC_TYPES.filter(
      (type) => bulkCustomClearanceFilesMap[type.code] && !bulkCustomClearanceFilesUploadedMap[type.code]
    );

    if (filesToUpload.length === 0) return;
    if (!bulkCustomClearanceDate) {
      message.error("Please select clearance date first");
      return;
    }

    setIsUploadingAll(true);

    const promises = filesToUpload.map((type) => {
      const file = bulkCustomClearanceFilesMap[type.code];
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve({
            file,
            docTypeCode: type.code,
            docTypeLabel: type.label,
            base64Data: reader.result,
          });
        };
        reader.onerror = (error) => {
          reject(error);
        };
      });
    });

    Promise.all(promises)
      .then((fileDatas) => {
        const importedSelectedOrders = orderSelectedInfo.filter(
          rec => rec.is_imported === true || rec.is_imported === "true"
        );
        const importedSelectedOrderIds = importedSelectedOrders.map(rec => rec.id);

        const itemPictures = [];
        const podPicSettings = [];

        fileDatas.forEach(({ file, docTypeCode, docTypeLabel, base64Data }) => {
          const ackId = Math.random().toString(36).substring(2, 15) + "_" + Date.now() + "_n";
          itemPictures.push({
            captured_at: new Date().toISOString(),
            picture_obj: file,
            ack_id: ackId,
            pic_title: docTypeLabel,
            pic_code: docTypeCode,
            image_type: "import",
            src: base64Data,
          });

          podPicSettings.push({
            pic_code: docTypeCode,
            mandatory: true,
            mandatory_for: ["driver", "billing"],
            required_for: "both",
          });
        });

        const payload = {
          refer: "order",
          order_ids: importedSelectedOrderIds,
          ref_ids: importedSelectedOrderIds,
          clearance_date: bulkCustomClearanceDate,
          customs_cleared_date: bulkCustomClearanceDate,
          org_id: currentOrg?.id || "",
          is_customs_cleared: true,
          pictures: [
            {
              refer_ids: importedSelectedOrderIds,
              item_pictures: itemPictures,
            },
          ],
          pod_pic_settings: podPicSettings,
        };

        return uploadCustomsClearanceFile(payload)
          .then((res) => {
            if (res && res.success) {
              setBulkCustomClearanceFilesUploadedMap((prev) => {
                const next = { ...prev };
                filesToUpload.forEach((type) => {
                  next[type.code] = true;
                });
                return next;
              });
              message.success("All documents uploaded successfully");
            } else {
              message.error(res?.errors || "Failed to upload documents");
            }
          });
      })
      .catch((err) => {
        console.error("Upload all error:", err);
        message.error("An error occurred during upload");
      })
      .finally(() => {
        setIsUploadingAll(false);
      });
  };

  const handleBulkCustomsClearanceSave = () => {
    setIsSavingBulkCustoms(true);
    setIsBulkCustomsClearanceModalVisible(false);
    setBulkCustomClearanceDate(null);
    setBulkCustomClearanceFilesMap({});
    setBulkCustomClearanceFilesUploadedMap({});
    setOrderSelectedInfo([]);
    clearAGGridCells(currentGridRef);
    refreshCallback();
    setIsSavingBulkCustoms(false);
  };

  const hasMultiDriverDelivery = orderSelectedInfo.some(order => order.is_multi_driver_delivery);
  
  const getCompletedLockedOrders = (records) => {
    return records.filter(rec => rec.status === 'COMPLETED' && rec.is_locked === 'true');
  };
  
  const completedLockedOrders = getCompletedLockedOrders(orderSelectedInfo);
  
  const hasMultiOrders = orderSelectedInfo.some(order => order?.type_of_order === 'MS') || false;
  const hasMultiOrdersAndSingleOrder = hasMultiOrders && orderSelectedInfo.length === 1;
  const hasImportedButNotCleared = orderSelectedInfo.some(rec => rec?.is_imported === true || rec?.is_imported === "true");
  const showCustomsClearanceBtn = orderSelectedInfo.length > 0 && orderSelectedInfo.every(rec => rec?.is_imported === true || rec?.is_imported === "true");

  const selectedWarehouseId = currentWh?.id || "";

  const quickDispatchAllowedForRecord = (rec) => {
    if (statusForActions['QUICK_DISPATCH'].status.includes(rec.status)) {
      return true;
    }
    if (
      isLegLevelAssignEnabled(organizationSettings) && filter !== "ASSIGNED" &&
      orderHasLegAwaitingAssignment(rec) && (rec?.origin?.status === "PENDING" || rec?.destination?.status === "PENDING")
    ) {
      return true;
    }
    return false;
  };

  const actionWiseStatus = {
    "SCHEDULE":  !orderSelectedInfo.some(rec => !statusForActions['SCHEDULE'].status.includes(rec.status)),
    "MOVE_TO_RECEIVED":  !orderSelectedInfo.some(rec => !statusForActions['MOVE_TO_RECEIVED'].status.includes(rec.status)),
    "QUICK_DISPATCH": !orderSelectedInfo.some(rec => !quickDispatchAllowedForRecord(rec)) && !hasMultiDriverDelivery && (hasMultiOrders ? hasMultiOrdersAndSingleOrder : true) && !hasImportedButNotCleared,
    "MOVE_TO_VERIFY":  !orderSelectedInfo.some(rec =>!statusForActions['MOVE_TO_VERIFY'].status.includes(rec.status)),
    "CHANGE_STATUS":   !orderSelectedInfo.some(rec => statusForActions['CHANGE_STATUS'].status.includes(rec.status)) && 
                       !orderSelectedInfo.some(rec => rec.status === 'COMPLETED' && rec.is_locked === 'true'),
    "PRINT_LABELS":  !orderSelectedInfo.some(rec => statusForActions['PRINT_LABELS'].status.includes(rec.status)),
    "CLONE_ORDERS":  !orderSelectedInfo.some(rec => !statusForActions['CLONE_ORDERS'].status.includes(rec.status)),
    "LINEHAUL":  !orderSelectedInfo.some(rec => !statusForActions['LINEHAUL'].status.includes(rec.status)),
    "SWITCH_ORDERS":  !orderSelectedInfo.some(rec => !statusForActions['SWITCH_ORDERS'].status.includes(rec.status)),
    "FSU_UPDATE":  !orderSelectedInfo.some(rec => !statusForActions['FSU_UPDATE'].status.includes(rec.status)),
    "BULK_DELETE":  !orderSelectedInfo.some(rec => !statusForActions['BULK_DELETE'].status.includes(rec.status)),
    "DISPATCH_STATUS": !orderSelectedInfo.some(rec => !statusForActions['DISPATCH_STATUS'].status.includes(rec.status)),
    "TENDER": statusForActions['TENDER'] ? !orderSelectedInfo.some(rec => !statusForActions['TENDER'].status.includes(rec.status)) : false,
  }

  const renderActionTooltipTitle = (action, haveAccess, isIncludes = true) => {
    if (action === 'QUICK_DISPATCH' && hasMultiDriverDelivery) {
      return "Multi-Man jobs cannot be assigned via Quick Dispatch.";
    }
    if (action === 'QUICK_DISPATCH' && hasImportedButNotCleared) {
      return "One or more selected orders are import orders.";
    }
    
    if (action === 'CHANGE_STATUS' && !haveAccess) {
      const invalidStatusOrders = orderSelectedInfo.filter(rec => statusForActions[action].status.includes(rec.status));
      
      if (completedLockedOrders.length > 0) {
        return "Completed and locked orders cannot be processed. Please remove these orders to proceed.";
      } else if (invalidStatusOrders.length > 0) {
        return `Orders with status ${statusForActions[action].status.join(',')} are only allowed to perform this action. Please remove other orders to proceed`;
      }
    }
    
    return haveAccess ? undefined : 
    isIncludes ? 
    `Orders with status ${statusForActions[action].status.join(',')} are only allowed to perform this action. Please remove other orders to proceed` : 
    `Orders status without ${statusForActions[action].status.join(',')} are allowed  to perform this action.` ;

  }

  const renderActionTooltipForMultiStopOrder = () => {
    return "Multi-stop orders cannot be assigned in group."
  }

  const columnStyle = (haveAccess) => {
    return (haveAccess ? {
        cursor:  "pointer",
        padding: "0px 10px",
        opacity: 1,
    } : {
        cursor:  'not-allowed',
        padding: "0px 10px",
        opacity:  0.5,
    })
  }
  const validateBulkActions = (
    records = [],
    action = "",
    cb = null,
   // errorCallback = null,
    isIncludes = true,
  ) => {
    const checkValidation = (allowedStatuses) => {
    if(action === "QUICK_DISPATCH"){
      return records
    .filter((rec) => {
      const hasCDKInOrigin = rec.origin?.label_code === 'CDK' && rec.origin?.status !== 'COMPLETED';
      const hasCDKInDestination = rec.destination?.label_code === 'CDK' && rec.origin?.status === 'COMPLETED' ;

      console.log(hasCDKInOrigin,hasCDKInDestination,'hasCDKInOrigin');
      

      // order_label === 'CDK' || order_label === 'WO'   --- always include
      if (rec.order_label === 'CDK' || rec.order_label === "WO") return true;

      // order_label === 'CDKD' --- check only destination
      if (rec.order_label === 'CDKD' && hasCDKInOrigin) return true;

      // order_label === 'PCDK' --- check only origin
      if (rec.order_label === 'PCDK' && hasCDKInDestination) return true;

      if (!hasQuickDispatchAssignableLegs(rec, organizationSettings, selectedWarehouseId)) {
        return true;
      }

      const failsStatus = isIncludes
        ? !allowedStatuses.includes(rec.status)
        : allowedStatuses.includes(rec.status);
      if (!failsStatus) return false;
      if (
        (rec?.origin?.status === "PENDING" || rec?.destination?.status === "PENDING") &&
        isLegLevelAssignEnabled(organizationSettings) && filter !== "ASSIGNED" &&
        orderHasLegAwaitingAssignment(rec)
      ) {
        return false;
      }
      return true;
    })
    .map((rec) => rec.customer_order_number);
    } else{
      return isIncludes ?
      records.filter((rec) => !allowedStatuses.includes(rec.status)).map(rec => rec.customer_order_number) :
      records.filter((rec) => allowedStatuses.includes(rec.status)).map(rec => rec.customer_order_number)
    }
    }
    if(!isEmpty(action)){
      let result = []
      let allowedStatuses = []
      switch (action) {
        case "SCHEDULE":
          allowedStatuses = statusForActions['SCHEDULE'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "MOVE_TO_RECEIVED":
          allowedStatuses = statusForActions['MOVE_TO_RECEIVED'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "QUICK_DISPATCH":
          allowedStatuses = statusForActions['QUICK_DISPATCH'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "MOVE_TO_VERIFY":
          allowedStatuses = statusForActions['MOVE_TO_VERIFY'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "CHANGE_STATUS":
          allowedStatuses = statusForActions['CHANGE_STATUS'].status;
          if (completedLockedOrders.length > 0) {
            result = completedLockedOrders.map(rec => rec.customer_order_number);
          } else {
            result = checkValidation(allowedStatuses);
          }
          break;
        case "PRINT_LABELS":
          allowedStatuses = statusForActions['PRINT_LABELS'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "CLONE_ORDERS":
          allowedStatuses = statusForActions['CLONE_ORDERS'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "LINEHAUL":
          allowedStatuses = statusForActions['LINEHAUL'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "SWITCH_ORDERS":
          allowedStatuses = statusForActions['SWITCH_ORDERS'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "FSU_UPDATE":
          allowedStatuses = statusForActions['FSU_UPDATE'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "BULK_DELETE":
          allowedStatuses = statusForActions['BULK_DELETE'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "DISPATCH_STATUS":
          allowedStatuses = statusForActions['DISPATCH_STATUS'].status;
          result = checkValidation(allowedStatuses);
          break;
        case "TENDER":
          allowedStatuses = statusForActions['TENDER'].status;
          result = checkValidation(allowedStatuses);
          break;
        default:
          break;
      }
      if(result.length === 0){
        cb();
      } else {
        const cdkOrderNumbers = records.filter((rec) => {
          const hasCDKInOrigin = rec.origin?.label_code === 'CDK' && rec.origin?.status !== 'COMPLETED';
          const hasCDKInDestination = rec.destination?.label_code === 'CDK' && rec.origin?.status === 'COMPLETED';
          return (
            (rec.order_label === 'CDK' || rec.order_label === 'WO') ||
            (rec.order_label === 'CDKD' && hasCDKInOrigin) ||
            (rec.order_label === 'PCDK' && hasCDKInDestination)
          );
        });
        if(isIncludes){
          if(action === "CHANGE_STATUS" && result.length > 0){
            if (completedLockedOrders.length > 0) {
              handleErrors([`${result.join(', ')} cannot be processed. Completed and locked orders are not allowed.`])
            } else {
              handleErrors([`${result.join(', ')} cannot be processed. Only orders with status ${allowedStatuses.join(',')} are allowed.`])
            }
          } else if(cdkOrderNumbers.length > 0){
            handleErrors([`${result.join(', ')} Cross Dock / ${I18n.t("general.warehouse")} orders cannot be processed.`])
          } else if (action === "QUICK_DISPATCH") {
            handleErrors([`${result.join(', ')} cannot be assigned from the current warehouse.`])
          } else{
            handleErrors([`${result.join(', ')} cannot be processed. Only orders with status ${allowedStatuses.join(',')}  are allowed.`])
          }
        } else{
          handleErrors(result, allowedStatuses, isIncludes)
        }
        
        // if(errorCallback){
        //   handleErrors(result)
        // } else {
        //   renderAlertMessage(`${result.join(',')} are not allowed`)
        // }
      }
    }
    
  };

  
  // const [operationFinished, setOperationFinished] = useState(false);

  // useEffect(() => {
  //   if (operationFinished) {
  //     handleCancel();
  //     setOperationFinished(false);
  //   }
  // }
  // , [operationFinished]);
  const handleStatusResult = (result, orderIds) => {
    if (result.success) {
      alertMessage(I18n.t('messages.successfully_done', {process: 'Status updated'}), 'success');
      if (props.refreshCallback) {
        props.refreshCallback();
      }
    } else {
      renderAlertMessage(result.errors || I18n.t('messages.something_went_wrong'), 'error');
    }
  };

  const handleErrors = (errors) => {
    setErrorOrders(errors)
  }

  const handleOptionChange = (value) => {
    setRejectionCode(value);
  };

  const getRejectionReason = () => {
    const organization_id = currentOrg.id;
    RejectedReasonApi.fetchRejectedReason(organization_id).then((result) => {
      if (result.success) {
        const rejectionMessages = result.rejection_messages || [];
        setApprovalRejections(rejectionMessages);
      } else {
        renderAlertMessage(result.errors)
      }
    });
  };

  useEffect(() => {
    if (filter === "PENDING") {
      getRejectionReason();
    }
  }, [filter]);

  const popoverContent = (
    <div style={{ width: 300 }} className="desc-container">
      <h4 style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold' }}>
        <span>New Feature! Quick Assign</span>
        <span className="icon">
          <RocketIcon className="alignRight" />
        </span>
      </h4>
      <p>
        You can now quickly assign orders to drivers from the orders screen
        without accessing preplan.
      </p>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button
          className="link-button"
          onClick={(e) => {
            e.preventDefault();
            setPopoverVisible(false);
            updateScreenConfig("order_listing", false, "show_quick_dispatch_feature_hint")
          }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );

  useEffect(() => {
    if (!statusChangeModal) {
      setIsChangeStatusClicked(false);
    }
  }, [statusChangeModal]);

  useEffect(() => {
    if (!showBarCodeModal) {
      setIsBarcodeClicked(false);
    }
  }, [showBarCodeModal]);

  useEffect(() => {
    if (!isModalVisible) {
      setIsExportClicked(false);
    }
  }, [isModalVisible]);

  useEffect(() => {
    const showMessage = _.get(
      currentUser,
      `screen_config.order_listing.show_quick_dispatch_feature_hint`,
      true
    )
    if(showMessage){
      setTimeout(() => {
          setPopoverVisible(true);
      }, 300);
    }
  }, []);

  const handlePendingApprove = () => {
    if (!isLoading) {
      enableLoading(true);
      const data = {
        order_ids: orderSelectedInfo.map(order => order.id),
        status: 'APPROVED',
        rejection_reason: 'Approved'
      }
      moveOrdersToNewFromPending(data)
        .then((result) => {
          handleStatusResult(result, data.order_ids);
          handleCancel();
        })
        .catch((error) => {
          renderAlertMessage(error.message, 'error', 10);
        })
        .finally(() => {
          enableLoading(false);
        });
    }
  };

  const handlePendingReject = () => {
    if (!isLoading) {
      setShowInfoWindow(true);
    }
  };

  const handleMoveToPending = () => {
    if (!isLoading) {
      enableLoading(true);
      handleMultipleOrdersStatusChange("PENDING");
    }
  };

  const handleBarcodeClick = () => {
    if (!isLoading) {
      handleBarCodePrint(true);
    }
  };

  const handleDelete = () => {
    if (!isLoading) {
      enableLoading(true);
      setConfirmBulkDelete();
    }
  };

  const handleRejectSubmit = (status, reason) => {
    enableLoading(true);
    const data = {
      order_ids: orderSelectedInfo.map(order => order.id),
      status: 'REJECTED',
      rejection_code: rejectionCode,
      rejection_reason: rejectionCode !== 'CUSTOM' ? reason : (rejectionReason || '')
    }
    moveOrdersToNewFromPending(data)
      .then((result) => {
        handleStatusResult(result, data.order_ids);
        setShowInfoWindow(false);
      })
      .catch((error) => {
        renderAlertMessage(error.message, 'error', 10);
      })
      .finally(() => {
        enableLoading(false);
      });
  };

  const handleRejectSave = () => {
    const selectedReason = approvalRejections
      .filter(msg => msg.rejection_code === rejectionCode)
      .map(message => message.rejection_message)
      .join(',');
    handleRejectSubmit("REJECTED", selectedReason);
  };

  const handleCustomRejectSave = () => {
    handleRejectSubmit("REJECTED", rejectionReason);
  };

  return (
    <div className="app-footer-container" data-testid="order-bulk-actions" style={{opacity: showAssignIcon && popoverVisible ? 0.65 : null}} onClick={()=> setPopoverVisible(false)}>
      {isTenderClicked && (
        <TenderOrdersModal
          visible={isTenderClicked}
          onClose={() => setIsTenderClicked(false)}
          selectedOrders={orderSelectedInfo}
          onTendered={() => {
            setOrderSelectedInfo([]);
            clearAGGridCells(currentGridRef);
            refreshCallback();
          }}
        />
      )}
      {Object.keys(statusForActions).length > 0 && <Row
        className="app-footer"
        type="flex"
        gutter={18}
        style={{ color: "#617AD6", fontWeight: "bold" }}
      >
        <Col className="alignLeft" style={{ color: "#444C52" }}>
          <Button
            data-testid="bulk-actions-close"
            type="primary"
            className="clearButtonStyle"
            style={{ marginTop: 15, marginLeft: 0 }}
            onClick={handleCancel}
            icon="close"
            shape="circle"
            size="large"
          />{" "}
          &nbsp;&nbsp;
          <SelectedOrdersList 
            organizationSettings={props.organizationSettings}
            errorOrders={errorOrders} 
            setErrorOrders={setErrorOrders} 
            currentGridRef={currentGridRef}
            userContext={userContext}
          /> 
          {/* {`${orderSelectedInfo.length} Orders`}&nbsp;&nbsp;&nbsp;&nbsp; */}
        </Col>
        {filter === "PENDING" && checkServiceExistance("COSU") && (
          <>
            <Col
              data-testid="approve-action"
              align="middle"
              justify="center"
              className={hoveredCol === 14 || isChangeStatusClicked ? "footer-hovered-col" : ""}
              onMouseEnter={() => setHoveredCol(14)}
              onMouseLeave={() => setHoveredCol(null)}
              style={{cursor: isLoading ? "not-allowed" : "pointer", padding: "0px 10px", opacity: isLoading ? 0.5 : 1}}
              onClick={handlePendingApprove}
            >
              <Row type="flex" align="middle" justify="center">
                <Col>
                  <Icon type={isLoading && isChangeStatusClicked ? "loading" : "file-done"} style={{ fontSize: 20, marginTop: 13 }} />
                </Col>
              </Row>
              <Row type="flex" align="middle" justify="center">
                <Col>Approve</Col>
              </Row>
            </Col>
            <Col
              data-testid="reject-action"
              align="middle"
              justify="center"
              className={hoveredCol === 15 || isChangeStatusClicked ? "footer-hovered-col" : ""}
              onMouseEnter={() => setHoveredCol(15)}
              onMouseLeave={() => setHoveredCol(null)}
              style={{cursor: isLoading ? "not-allowed" : "pointer", padding: "0px 10px", opacity: isLoading ? 0.5 : 1}}
              onClick={handlePendingReject}
            >
              <Row type="flex" align="middle" justify="center">
                <Col>
                  <Icon type={isLoading && isChangeStatusClicked ? "loading" : "close-circle"} style={{ fontSize: 20, marginTop: 13 }} />
                </Col>
              </Row>
              <Row type="flex" align="middle" justify="center">
                <Col>Reject</Col>
              </Row>
            </Col>
            {checkServiceExistance("SBA") && (
              <Col
                data-testid="barcode-action"
                align="middle"
                justify="center"
                className={hoveredCol === 16 || isBarcodeClicked ? "footer-hovered-col" : ""}
                onMouseEnter={() => setHoveredCol(16)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{cursor: "pointer", padding: "0px 10px"}}
                onClick={handleBarcodeClick}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon type={isLoading && isBarcodeClicked ? "loading" : "printer"} style={{ fontSize: 20, marginTop: 13 }} />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col>Barcode</Col>
                </Row>
              </Col>
            )}
            {checkServiceExistance("COD") && (
              <Col
                data-testid="delete-action"
                align="middle"
                justify="center"
                className={hoveredCol === 17 || isChangeStatusClicked ? "delete-hovered-col textRed" : ""}
                onMouseEnter={() => setHoveredCol(17)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{cursor: isLoading ? "not-allowed" : "pointer", padding: "0px 10px", opacity: isLoading ? 0.5 : 1}}
                onClick={handleDelete}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon type={isLoading && isChangeStatusClicked ? "loading" : "delete"} style={{ fontSize: 20, marginTop: 13 }} />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col>Delete</Col>
                </Row>
              </Col>
            )}
          </>
        )}
        {filter === "REJECTED" && checkServiceExistance("COSU") && (
          <>
            <Col
              data-testid="pending-action"
              align="middle"
              justify="center"
              className={hoveredCol === 16 || isChangeStatusClicked ? "footer-hovered-col" : ""}
              onMouseEnter={() => setHoveredCol(16)}
              onMouseLeave={() => setHoveredCol(null)}
              style={{cursor: isLoading ? "not-allowed" : "pointer", padding: "0px 10px", opacity: isLoading ? 0.5 : 1}}
              onClick={handleMoveToPending}
            >
              <Row type="flex" align="middle" justify="center">
                <Col>
                  <Icon type={isLoading && isChangeStatusClicked ? "loading" : "rollback"} style={{ fontSize: 20, marginTop: 13 }} />
                </Col>
              </Row>
              <Row type="flex" align="middle" justify="center">
                <Col>Move to Pending</Col>
              </Row>
            </Col>
            {checkServiceExistance("SBA") && (
              <Col
                data-testid="barcode-action"
                align="middle"
                justify="center"
                className={hoveredCol === 17 || isBarcodeClicked ? "footer-hovered-col" : ""}
                onMouseEnter={() => setHoveredCol(17)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{cursor: "pointer", padding: "0px 10px"}}
                onClick={handleBarcodeClick}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon type={isLoading && isBarcodeClicked ? "loading" : "printer"} style={{ fontSize: 20, marginTop: 13 }} />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col>Barcode</Col>
                </Row>
              </Col>
            )}
            {checkServiceExistance("COD") && (
              <Col
                data-testid="delete-action"
                align="middle"
                justify="center"
                className={hoveredCol === 18 || isChangeStatusClicked ? "delete-hovered-col textRed" : ""}
                onMouseEnter={() => setHoveredCol(18)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{cursor: isLoading ? "not-allowed" : "pointer", padding: "0px 10px", opacity: isLoading ? 0.5 : 1}}
                onClick={handleDelete}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon type={isLoading && isChangeStatusClicked ? "loading" : "delete"} style={{ fontSize: 20, marginTop: 13 }} />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col>Delete</Col>
                </Row>
              </Col>
            )}
          </>
        )}
        {filter !== "PENDING" && filter !== "REJECTED" && (
          <>
            {checkServiceExistance("SBA") &&
              //["NEW", "RECEIVED", "VERIFIED", "ON_HOLD"].includes(filter) && 
              (
                <Col
                  data-testid="schedule-action"
                  align="middle"
                  justify="center"
                  style={{...columnStyle(actionWiseStatus['SCHEDULE'])}}
                  className={
                    hoveredCol === 1 || isChildContainerClicked
                      ? "footer-hovered-col"
                      : ""
                  }
                  onMouseEnter={() => setHoveredCol(1)}
                  onMouseLeave={() => setHoveredCol(null)}
                  //onClick={handleClick}
                  onClick={() => validateBulkActions(
                    orderSelectedInfo,
                    'SCHEDULE',
                    () => {handleClick()}
                  )}
                >
                <Tooltip title={renderActionTooltipTitle('SCHEDULE',actionWiseStatus['SCHEDULE'], statusForActions['SCHEDULE'].isIncludes)}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon
                        type="calendar"
                        style={{ fontSize: 20, marginTop: 13 }}
                      />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <OptingAppointment
                        resetOrders={() => resetOrders(true)}
                        orders={selectedKeys || []}
                        filter={filter}
                        warehouseFilter={warehouseFilter}
                        organizationSettings={organizationSettings}
                        selectedOrders={orderSelectedInfo || []}
                        showSelectedOrder={true}
                        isFromBulkContainer={true}
                        isChildContainerClicked={isChildContainerClicked}
                        setIsChildContainerClicked={setIsChildContainerClicked}
                        setIsHovered={setHoveredCol}
                        showSchduleOption={true}
                        resetSelection={handleCancel}
                      />
                    </Col>
                  </Row>
                </Tooltip>
                </Col>
              )}
            {checkServiceExistance("COSU") &&
            // filter === "NEW" && 
              (
              <Col
                data-testid="received-action"
                align="middle"
                justify="center"
                className={hoveredCol === 2 ? "footer-hovered-col" : ""}
                onMouseEnter={() => setHoveredCol(2)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{...columnStyle(actionWiseStatus['MOVE_TO_RECEIVED'])}}
               // onClick={() => handleMultipleOrdersStatusChange("RECEIVED")}
                onClick={() =>
                  actionWiseStatus['MOVE_TO_RECEIVED'] ?
                    validateBulkActions(
                      orderSelectedInfo,
                      'MOVE_TO_RECEIVED',
                      () => { handleMultipleOrdersStatusChange("RECEIVED") }
                    )
                    : () => { }
                }
              >
              <Tooltip title={renderActionTooltipTitle('MOVE_TO_RECEIVED', actionWiseStatus['MOVE_TO_RECEIVED'], statusForActions['MOVE_TO_RECEIVED'].isIncludes)}>
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon
                      type="check-square"
                      style={{ fontSize: 20, marginTop: 13 }}
                    />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col>Mark Received</Col>
                </Row>
              </Tooltip>
              </Col>
            )}
            {showAssignIcon && checkServiceExistance("COSU") &&
             // ["NEW", "RECEIVED", "VERIFIED"].includes(filter) && 
            (
                <Popover
                      content={popoverContent}
                      title={null}
                      overlayStyle={{ maxWidth: 500 }}
                      placement="topLeft"
                      overlayClassName="custom-popover"
                      visible={popoverVisible}

                    >
                  <Col
                    data-testid="assign-action"
                    align="middle"
                    justify="center"
                    className={
                      hoveredCol === 11 || isAssignClicked ? "footer-hovered-col" : ""
                    }
                    onMouseEnter={() => setHoveredCol(11)}
                    onMouseLeave={() => setHoveredCol(null)}
                    style={{...columnStyle(actionWiseStatus['QUICK_DISPATCH'])}}
                    // onClick={() => setIsAssignClicked(true)}
                    onClick={() => {
                      if (!actionWiseStatus['QUICK_DISPATCH'] || hasMultiDriverDelivery || (hasMultiOrders && !hasMultiOrdersAndSingleOrder)) {
                        return; 
                      }
                      validateBulkActions(orderSelectedInfo,
                      'QUICK_DISPATCH',
                      () => { setIsAssignClicked(true)})
                    }}
                  >

                  <Tooltip title={hasMultiOrders && !hasMultiOrdersAndSingleOrder ? renderActionTooltipForMultiStopOrder() : renderActionTooltipTitle('QUICK_DISPATCH', actionWiseStatus['QUICK_DISPATCH'], statusForActions['QUICK_DISPATCH'].isIncludes)}>
                    <Row type="flex" align="middle" justify="center">
                      <Col>
                        <AssignIcon
                          style={{ fontSize: 20, marginTop: 9 }}
                          color="#617AD6"
                        />
                      </Col>
                    </Row>
                    <Row type="flex" align="middle" justify="center">
                      <Col data-testid="assign-modal">
                        <AssignOrders
                          selectedOrders={orderSelectedInfo}
                          screenFrom={"orders_list"}
                          isAssignClicked={isAssignClicked}
                          setIsAssignClicked={setIsAssignClicked}
                          setIsHovered={setHoveredCol}
                          currentOrg={currentOrg}
                          organizationSettings={props.organizationSettings}
                          setOrderSelectedInfo={setOrderSelectedInfo}
                          orderRefreshCall={() => {
                            setOrderSelectedInfo([])
                            clearAGGridCells(currentGridRef)
                            refreshCallback()
                          }}
                        />
                      </Col>
                    </Row>
                  </Tooltip>
                  </Col>
                </Popover>
              )}
            {showTenderAction && (
              <Col
                data-testid="tender-action"
                align="middle"
                justify="center"
                className={
                  hoveredCol === 19 || isTenderClicked ? "footer-hovered-col" : ""
                }
                onMouseEnter={() => setHoveredCol(19)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{ ...columnStyle(actionWiseStatus['TENDER']) }}
                onClick={() =>
                  actionWiseStatus['TENDER'] ?
                    validateBulkActions(
                      orderSelectedInfo,
                      'TENDER',
                      () => { setIsTenderClicked(true) }
                    )
                    : () => { }
                }
              >
                <Tooltip title={renderActionTooltipTitle('TENDER', actionWiseStatus['TENDER'], statusForActions['TENDER'].isIncludes)}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <TenderIcon
                        style={{ fontSize: 20, marginTop: 13 }}
                        color="#617AD6"
                        width="20"
                        height="18"
                      />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>Tender</Col>
                  </Row>
                </Tooltip>
              </Col>
            )}
            
            {checkServiceExistance("CAMV") && !isLtlOrganization(currentOrg) &&
            // filter === "RECEIVED" &&
            (
              <Col
                data-testid="verified-action"
                align="middle"
                justify="center"
                className={hoveredCol === 3 ? "footer-hovered-col" : ""}
                onMouseEnter={() => setHoveredCol(3)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{...columnStyle(actionWiseStatus['MOVE_TO_VERIFY'])}}
                // onClick={() => handleReceiveToConfirm()}
                onClick={() => 
                  actionWiseStatus['MOVE_TO_VERIFY'] ?
                    validateBulkActions(
                      orderSelectedInfo,
                      'MOVE_TO_VERIFY',
                      () => { handleReceiveToConfirm() }
                    )
                    : () => { }
                }
              >
               <Tooltip title={renderActionTooltipTitle('MOVE_TO_VERIFY',actionWiseStatus['MOVE_TO_VERIFY'], statusForActions['MOVE_TO_VERIFY'].isIncludes)}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon
                        type="check-circle"
                        style={{ fontSize: 20, marginTop: 13 }}
                      />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>Mark Verified</Col>
                  </Row>
                </Tooltip>
              </Col>
            )}            
            {checkServiceExistance("COSU") &&
              (
              <Col
                data-testid="status-action"
                align="middle"
                justify="center"
                className={
                  hoveredCol === 4 || isChangeStatusClicked
                    ? "footer-hovered-col"
                    : ""
                }
                onMouseEnter={() => setHoveredCol(4)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{ ...columnStyle(actionWiseStatus['CHANGE_STATUS']) }}
            
                  onClick={() =>
                    actionWiseStatus['CHANGE_STATUS'] ?
                    validateBulkActions(orderSelectedInfo,
                      'CHANGE_STATUS',
                      () => { 
                        changeStatus();
                        setIsChangeStatusClicked(true);
                      },
                      statusForActions['CHANGE_STATUS'].isIncludes)
                      : () => { }
                  }

              >
                <Tooltip title={renderActionTooltipTitle('CHANGE_STATUS', actionWiseStatus['CHANGE_STATUS'], statusForActions['CHANGE_STATUS'].isIncludes)}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon type="flag" style={{ fontSize: 20, marginTop: 13 }} />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col> Change Status </Col>
                  </Row>
                </Tooltip>
              </Col>
              )}
            <Col
              data-testid="dispatch-status-action"
              align="middle"
              justify="center"
              className={
                hoveredCol === 13 || isChangeStatusClicked
                  ? "footer-hovered-col"
                  : ""
              }
              onMouseEnter={() => setHoveredCol(13)}
              onMouseLeave={() => setHoveredCol(null)}
              style={{ ...columnStyle(actionWiseStatus['DISPATCH_STATUS']), marginRight: 12 }}
              onClick={() => validateBulkActions(orderSelectedInfo,
                'DISPATCH_STATUS',
                () => {
                  setChangeDispatchStatus(true)
                })}
            >
              <Tooltip title={renderActionTooltipTitle('DISPATCH_STATUS', actionWiseStatus['DISPATCH_STATUS'], statusForActions['DISPATCH_STATUS'].isIncludes)}>
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon type="bg-colors" style={{ fontSize: 20, marginTop: 13 }} />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col> Dispatch Status</Col>
                </Row>
              </Tooltip>
            </Col>
            {checkServiceExistance("SBA") && (
              <Col
                data-testid="print-label-action"
                align="middle"
                justify="center"
                className={
                  hoveredCol === 5 || isPrintLabelClicked
                    ? "footer-hovered-col"
                    : ""
                }
                onMouseEnter={() => setHoveredCol(5)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{...columnStyle(actionWiseStatus['PRINT_LABELS'])}}
                onClick={() => validateBulkActions(orderSelectedInfo,
                  'PRINT_LABELS',
                  () => { 
                    setIsPrintLabelClicked(true)
                  },
                  statusForActions['PRINT_LABELS'].isIncludes)
                }
              >
                <Tooltip title={renderActionTooltipTitle('PRINT_LABELS', actionWiseStatus['PRINT_LABELS'], statusForActions['PRINT_LABELS'].isIncludes)}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon type="printer" style={{ fontSize: 20, marginTop: 13 }} />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <PrintLabels
                        className=""
                        buttonType={null}
                        label={I18n.t("order.print_labels")}
                        isDisabled={selectedKeys.length === 0}
                        handleSuccess={() => {}}
                        orderIds={[...selectedKeys]}
                        size={null}
                        buttonIcon={null}
                        isFromBulkContainer={true}
                        isPrintLabelClicked={isPrintLabelClicked}
                        setIsPrintLabelClicked={setIsPrintLabelClicked}
                        setIsHovered={setHoveredCol}
                      />
                    </Col>
                  </Row>
                </Tooltip>
              </Col>
            )}
            {/* {checkServiceExistance("SBA") && (
              <Col
                align="middle"
                justify="center"
                className={
                  hoveredCol === 12 || isExportClicked ? "footer-hovered-col" : ""
                }
                onMouseEnter={() => setHoveredCol(12)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{
                  cursor: "pointer",
                  padding: "0px 10px",
                }}
                onClick={() => {
                  handleExportToExcel();
                  setIsExportClicked(true);
                }}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <ExcelIcon
                      style={{ fontSize: 20, marginTop: 9 }}
                      color="#617AD6"
                    />
                  </Col>
                </Row>
                <Row type0="flex" align="middle" justify="center">
                  <Col>Export</Col>
                </Row>
              </Col>
            )} */}
            {checkServiceExistance("SBA") &&
              // ["NEW", "RECEIVED", "VERIFIED", "ON_HOLD"].includes(filter) && 
            (
                <Col
                  data-testid="clone-action"
                  align="middle"
                  justify="center"
                  className={
                    hoveredCol === 6 || isCloneClicked ? "footer-hovered-col" : ""
                  }
                  onMouseEnter={() => setHoveredCol(6)}
                  onMouseLeave={() => setHoveredCol(null)}
                  style={{...columnStyle(actionWiseStatus['CLONE_ORDERS'])}}
                  // onClick={() => setIsCloneClicked(true)}
                  onClick={() => validateBulkActions(orderSelectedInfo,
                    'CLONE_ORDERS',
                    () => { 
                      setIsCloneClicked(true)
                    })}
                >
                <Tooltip title={renderActionTooltipTitle('CLONE_ORDERS', actionWiseStatus['CLONE_ORDERS'], statusForActions['PRINT_LABELS'].isIncludes)}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon type="copy" style={{ fontSize: 20, marginTop: 13 }} />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <CloneOrders
                        resetOrders={() => resetOrders(true)}
                        orders={selectedKeys || []}
                        filter={filter}
                        handleEditOrder={handleEditOrder}
                        warehouseFilter={warehouseFilter}
                        organizationSettings={organizationSettings}
                        selectedOrders={orderSelectedInfo || []}
                        showSelectedOrder={true}
                        isFromBulkContainer={true}
                        isCloneClicked={isCloneClicked}
                        setIsCloneClicked={setIsCloneClicked}
                        setIsHovered={setHoveredCol}
                        resetSelection={handleCancel}
                      />
                    </Col>
                  </Row>
                  </Tooltip>
                </Col>
              )}

            <Popconfirm
              title="Are you sure you want to download the consolidated BOL?"
              onConfirm={handleBolDownload}
              okText="Yes"
              cancelText="No"
              disabled={isLoading}
            >
              <Col
                data-testid="bol-action"
                align="middle"
                justify="center"
                className={hoveredCol === 11 || isBolClicked ? "footer-hovered-col" : ""}
                onMouseEnter={() => setHoveredCol(11)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{
                  cursor: isLoading ? "not-allowed" : "pointer",
                  padding: "0px 10px",
                  marginRight: filter === "ASSIGNED" ? 12 : null,
                  opacity: isLoading ? 0.5 : 1,
                }}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon
                      type={isLoading ? "loading" : "file-done"}
                      style={{ fontSize: 20, marginTop: 13 }}
                    />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col>BOL</Col>
                </Row>
              </Col>
            </Popconfirm>

            {checkServiceExistance("SBA") &&
              !["PENDING", "REJECTED"].includes(filter) && (
              <Col
                data-testid="barcode-action"
                align="middle"
                justify="center"
                className={
                  hoveredCol === 7 || isBarcodeClicked
                    ? "footer-hovered-col"
                    : ""
                }
                onMouseEnter={() => setHoveredCol(7)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{
                  cursor: "pointer",
                  padding: "0px 10px",
                  marginRight: filter === "ASSIGNED" ? 12 : null,
                }}
                onClick={() => {
                  handleBarCodePrint(true);
                  setIsBarcodeClicked(true);
                }}
              >
                <Row type="flex" align="middle" justify="center">
                  <Col>
                    <Icon type="printer" style={{ fontSize: 20, marginTop: 13 }} />
                  </Col>
                </Row>
                <Row type="flex" align="middle" justify="center">
                  <Col>Barcode</Col>
                </Row>
              </Col>
            )}
            {checkServiceExistance("SBA") && IsLinehaulLegacy &&
              // ["NEW", "RECEIVED", "VERIFIED"].includes(filter) && 
              (
                <Col
                  data-testid="linehaul-action"
                  align="middle"
                  justify="center"
                  className={
                    hoveredCol === 8 || isLinehaulClicked
                      ? "footer-hovered-col"
                      : ""
                  }
                  onMouseEnter={() => setHoveredCol(8)}
                  onMouseLeave={() => setHoveredCol(null)}
                  style={{...columnStyle(actionWiseStatus['LINEHAUL'])}}
                 // onClick={() => setIsLinehaulClicked(true)}
                  onClick={() => validateBulkActions(orderSelectedInfo,
                    'LINEHAUL',
                    () => { 
                      setIsLinehaulClicked(true)
                    })
                  }
                >
                <Tooltip title={renderActionTooltipTitle('LINEHAUL', actionWiseStatus['LINEHAUL'], statusForActions['LINEHAUL'].isIncludes)}>

                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon
                        type="gateway"
                        style={{ fontSize: 20, marginTop: 13 }}
                      />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <BulkLinehaulForm
                        resetOrders={() => resetOrders(true)}
                        orders={orderSelectedInfo || []}
                        filter={filter}
                        creditsExceededAccnts={creditsExceededAccnts}
                        handleEditOrder={handleEditOrder}
                        orderNumbersSelected={true}
                        warehouseFilter={warehouseFilter}
                        organizationSettings={organizationSettings}
                        isFromBulkContainer={true}
                        isLinehaulClicked={isLinehaulClicked}
                        setIsLinehaulClicked={setIsLinehaulClicked}
                        setIsHovered={setHoveredCol}
                      />
                    </Col>
                  </Row>
                  </Tooltip>
                </Col>
              )}
            {checkServiceExistance("SBA") && !isLtlOrganization(currentOrg) &&
            //  ["NEW", "RECEIVED", "VERIFIED"].includes(filter) &&
            (
                <Col
                  data-testid="switch-details-action"
                  align="middle"
                  justify="center"
                  className={
                    hoveredCol === 9 || isSwitchOrderClicked
                      ? "footer-hovered-col"
                      : ""
                  }
                  onMouseEnter={() => setHoveredCol(9)}
                  onMouseLeave={() => setHoveredCol(null)}
                  style={{...columnStyle(actionWiseStatus['SWITCH_ORDERS'])}}
                  //onClick={() => setIsSwitchOrderClicked(true)}
                  onClick={() => validateBulkActions(orderSelectedInfo,
                    'SWITCH_ORDERS',
                    () => {
                      setIsSwitchOrderClicked(true)
                    })
                  }
                >
                <Tooltip title={renderActionTooltipTitle('SWITCH_ORDERS', actionWiseStatus['SWITCH_ORDERS'], statusForActions['LINEHAUL'].isIncludes)}>

                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon type="swap" style={{ fontSize: 20, marginTop: 13 }} />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <SwitchOrder
                        selectedOrders={orderSelectedInfo}
                        refreshOrders={getOrders}
                        resetOrders={() => resetOrders(true)}
                        clearOrders={handleCancel}
                        isFromBulkContainer={true}
                        isSwitchOrderClicked={isSwitchOrderClicked}
                        setIsSwitchOrderClicked={setIsSwitchOrderClicked}
                        setIsHovered={setHoveredCol}
                        resetSelection={handleCancel}
                      />
                    </Col>
                  </Row>
                </Tooltip>
                </Col>
              )}
            {checkServiceExistance("SBA") && isLtlOrganization(currentOrg) && (
                <Col
                  data-testid="fsu-update-status-action"
                  align="middle"
                  justify="center"
                  className={
                    hoveredCol === 9 || isFsuUpdateClicked
                      ? "footer-hovered-col"
                      : ""
                  }
                  onMouseEnter={() => setHoveredCol(9)}
                  onMouseLeave={() => setHoveredCol(null)}
                  style={{...columnStyle(actionWiseStatus['FSU_UPDATE'])}}
                  onClick={() => validateBulkActions(orderSelectedInfo,
                    'FSU_UPDATE',
                    () => {
                      setIsFsuUpdateClicked(true)
                    })
                  }
                >
                <Tooltip title={renderActionTooltipTitle('FSU_UPDATE', actionWiseStatus['FSU_UPDATE'], statusForActions['FSU_UPDATE'].isIncludes)}>

                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon type="sync" style={{ fontSize: 20, marginTop: 13 }} />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <FsuUpdateStatus
                        selectedOrders={orderSelectedInfo}
                        refreshOrders={getOrders}
                        resetOrders={() => resetOrders(true)}
                        clearOrders={handleCancel}
                        isFromBulkContainer={true}
                        isFsuUpdateClicked={isFsuUpdateClicked}
                        setIsFsuUpdateClicked={setIsFsuUpdateClicked}
                        setIsHovered={setHoveredCol}
                        resetSelection={handleCancel}
                      />
                    </Col>
                  </Row>
                </Tooltip>
                </Col>
              )}
            {showCustomsClearanceBtn && (
              <Col
                data-testid="bulk-customs-clearance-action"
                align="middle"
                justify="center"
                className={
                  hoveredCol === 15 || isBulkCustomsClearanceModalVisible
                    ? "footer-hovered-col"
                    : ""
                }
                onMouseEnter={() => setHoveredCol(15)}
                onMouseLeave={() => setHoveredCol(null)}
                style={{
                  cursor: isLoading ? "not-allowed" : "pointer",
                  padding: "0px 10px",
                  opacity: isLoading ? 0.5 : 1,
                }}
                onClick={() => {
                  if (!isLoading) {
                    setIsBulkCustomsClearanceModalVisible(true);
                  }
                }}
              >
                <Tooltip title="Update Customs Clearance Details for selected import orders">
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon type="safety" style={{ fontSize: 20, marginTop: 13 }} />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>Customs Clearance</Col>
                  </Row>
                </Tooltip>
              </Col>
            )}



            {checkServiceExistance("COD") &&
              // [
              //   "NEW",
              //   "RECEIVED",
              //   "VERIFIED",
              //   "PENDING",
              //   "APPROVED",
              //   "REJECTED",
              //   "ON_HOLD",
              // ].includes(filter) && 
              (
                <Col
                  data-testid="delete-action"
                  align="middle"
                  justify="center"
                  className={
                    hoveredCol === 10 || confirmBulkDelete
                      ? "delete-hovered-col textRed"
                      : ""
                  }
                  onMouseEnter={() => setHoveredCol(10)}
                  onMouseLeave={() => setHoveredCol(null)}
                  style={{...columnStyle(actionWiseStatus['BULK_DELETE']), marginRight: 12}}
                  // onClick={setConfirmBulkDelete}
                  onClick={() => validateBulkActions(orderSelectedInfo,
                    'BULK_DELETE',
                    () => { 
                      setConfirmBulkDelete()
                    })}
                  
                >
                <Tooltip title={renderActionTooltipTitle('BULK_DELETE', actionWiseStatus['BULK_DELETE'], statusForActions['BULK_DELETE'].isIncludes)}>
                  <Row type="flex" align="middle" justify="center">
                    <Col>
                      <Icon type="delete" style={{ fontSize: 20, marginTop: 13 }} />
                    </Col>
                  </Row>
                  <Row type="flex" align="middle" justify="center">
                    <Col>Delete</Col>
                  </Row>
                  </Tooltip>
                </Col>
              )}
          </>
        )}
      </Row>}
      {showInfoWindow && (
        <BaseModal
          title={I18n.t('general.reason')}
          className="customer-orders-modal"
          onCancel={() => {
            setShowInfoWindow(false);
          }}
          width="30%"
          maskClosable={false}
        >
          <Row>
            <Col span={24}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <h4 style={{ marginBottom: '0', marginRight: '10px' }}>{I18n.t("general.rejection_to_reason")}</h4>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Select 
                    onChange={handleOptionChange} 
                    value={rejectionCode} 
                    style={{ marginLeft: '10px',width:'200px' }}
                    disabled={isLoading}
                  >
                    <Select.Option value="NONE">{I18n.t("general.none")}</Select.Option>
                    <Select.Option value="CUSTOM">{I18n.t("general.custom_message")}</Select.Option>
                    {approvalRejections.map((message) => (
                      <Select.Option key={message.id} value={message.rejection_code}>
                        {message.rejection_message}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>
            </Col>
          </Row>
          
          {rejectionCode !== 'CUSTOM' ? (
            <Row>
              <Col span={24}>
                <div style={{ textAlign: 'center' }}>
                  <Button
                    onClick={() => setShowInfoWindow(false)}
                    icon="close"
                    style={{
                      marginRight: '10px',
                      marginTop: '10px',
                      width: '100px',
                      height: '40px',
                    }}
                    disabled={isLoading}
                  >
                    {I18n.t("general.close")}
                  </Button>
                  <Button
                    onClick={handleRejectSave}
                    className="assignDriver"
                    style={{
                      margin: '10px',
                      marginTop: '10px',
                      width: '100px',
                      height: '40px',
                    }}
                    type="primary"
                    icon={isLoading ? "loading" : "save"}
                    disabled={isLoading}
                  >
                    {I18n.t("general.save")}
                  </Button>
                </div>
              </Col>
            </Row>
          ) : rejectionCode === 'CUSTOM' ? (
            <Row>
              <Col span={24}>
                <div style={{ marginTop: '20px' }}>
                  <ReasonWindow
                    reasonElement={'rejection_reason'}
                    reasonValue={rejectionReason}
                    handleOnChange={(element, value) => {
                      setRejectionReason(value);
                    }}
                    closeReasonModal={() => setShowInfoWindow(false)}
                    saveReason={handleCustomRejectSave}
                    disabled={isLoading}
                  />
                </div>
              </Col>
            </Row>
          ) : null}
        </BaseModal>
      )}
      {isBulkCustomsClearanceModalVisible && (
        <BaseModal
          title="Customs Clearance Details"
          visible={isBulkCustomsClearanceModalVisible}
          onCancel={() => {
            setIsBulkCustomsClearanceModalVisible(false);
            setBulkCustomClearanceDate(null);
            setBulkCustomClearanceFilesMap({});
          }}
          footer={[
            <Button
              data-testid="cancel-bulk-custom-clearance-button"
              key="cancel"
              className="medium-btn flat"
              type="link"
              onClick={() => {
                setIsBulkCustomsClearanceModalVisible(false);
                setBulkCustomClearanceDate(null);
                setBulkCustomClearanceFilesMap({});
              }}
              disabled={isSavingBulkCustoms}
            >
              Cancel
            </Button>,
            <Button
              data-testid="save-bulk-custom-clearance-button"
              key="save"
              className="medium-btn flat"
              type="link"
              onClick={handleBulkCustomsClearanceSave}
              disabled={!bulkCustomClearanceDate || !CUSTOMS_DOC_TYPES.some(type => bulkCustomClearanceFilesUploadedMap[type.code]) || isSavingBulkCustoms}
              loading={isSavingBulkCustoms}
            >
              Update Changes 
            </Button>,
          ]}
          width="550px"
          maskClosable={false}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <div>
              <div className="caption-large-emphasis" style={{ marginBottom: "4px" }}>
                Clearance Date
                <sup style={{ color: 'red' }}>*</sup>
              </div>
              <DatePicker
                data-testid="bulk-clearance-date-picker"
                value={bulkCustomClearanceDate ? moment(bulkCustomClearanceDate) : null}
                onChange={(date, dateString) => setBulkCustomClearanceDate(dateString)}
                style={{ width: "100%" }}
                placeholder="Select Date"
                disabled={isSavingBulkCustoms}
              />
            </div>

            <div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <span className="caption-large-emphasis">Required Customs Documents</span>
                {CUSTOMS_DOC_TYPES.some(type => bulkCustomClearanceFilesMap[type.code] && !bulkCustomClearanceFilesUploadedMap[type.code]) && (
                  <Button
                    data-testid="upload-all-customs-docs-btn"
                    className="medium-btn flat"
                    type="link"
                    onClick={handleUploadAllCustomsFiles}
                    loading={isUploadingAll}
                    style={{ display: "flex", alignItems: "center", gap: "4px", height: "28px", fontSize: "12px", padding: "0 8px" }}
                  >
                    {!isUploadingAll && <Icon type="upload" />}
                    <span>Upload</span>
                  </Button>
                )}
              </div>
              <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "4px" }}>
                {CUSTOMS_DOC_TYPES.map((type) => {
                  const file = bulkCustomClearanceFilesMap[type.code];

                  return (
                    <div
                      key={type.code}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "8px 12px",
                        background: "#fafafa",
                        border: "1px solid #f0f0f0",
                        borderRadius: "6px",
                        marginBottom: "8px"
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column", gap: "2px", maxWidth: "55%" }}>
                        <span className="caption-large-emphasis" style={{ textTransform: "capitalize", color: "#111314", fontSize: "12px" }}>
                          {type.label}
                        </span>
                      </div>
                      <div>
                        {file ? (
                          <div style={{ display: "flex", alignItems: "center", gap: "8px", background: "#e6f7ff", border: "1px solid #91d5ff", padding: "4px 8px", borderRadius: "4px" }}>
                            <span style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "11px", color: "#0050b3" }}>
                              <Icon type="paper-clip" style={{ marginRight: "4px" }} />
                              {file.name}
                            </span>
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                              <Tooltip title="Preview">
                                <Icon
                                  type="eye"
                                  style={{ color: "#1890ff", cursor: "pointer", fontSize: "13px" }}
                                  onClick={() => {
                                    const objectUrl = URL.createObjectURL(file);
                                    const isPdf = file?.type === "application/pdf" || file?.name?.toLowerCase().endsWith(".pdf");
                                    setDocPreviewUrl(objectUrl);
                                    setDocPreviewType(isPdf ? "pdf" : "image");
                                    setDocPreviewVisible(true);
                                  }}
                                />
                              </Tooltip>
                              {bulkCustomClearanceFilesUploadedMap[type.code] && (
                                <Icon type="check-circle" theme="filled" style={{ color: "#52c41a", fontSize: "13px" }} />
                              )}
                              <Tooltip title="Remove">
                                <Icon
                                  type="delete"
                                  style={{ color: "#ff4d4f", cursor: "pointer", fontSize: "13px" }}
                                  onClick={() => handleBulkRemoveFile(type.code)}
                                />
                              </Tooltip>
                            </div>
                          </div>
                        ) : (
                          <Upload
                            beforeUpload={(f) => {
                              const isLt2M = f.size / 1024 / 1024 < 2;
                              if (!isLt2M) {
                                message.error("Image/File must be smaller than 2MB!");
                                return false;
                              }
                              handleBulkFileSelect(f, type.code);
                              return false;
                            }}
                            showUploadList={false}
                            accept=".pdf,image/*"
                            disabled={isSavingBulkCustoms}
                          >
                            <Button style={{ display: "flex", alignItems: "center", gap: "4px", borderRadius: "4px", height: "28px", fontSize: "11px", border: "1px dashed #d9d9d9", color: "#576ec1", background: "#f9fbfd" }}>
                              <Icon type="upload" /> Select File
                            </Button>
                          </Upload>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </BaseModal>
      )}

      {/* Doc Preview Modal */}
      <Modal
        visible={docPreviewVisible}
        footer={null}
        onCancel={() => setDocPreviewVisible(false)}
        centered
        width={docPreviewType === "pdf" ? 800 : "auto"}
        bodyStyle={{ padding: 0, textAlign: "center" }}
        title={
          <span style={{ fontSize: "13px", color: "#576ec1" }}>
            {docPreviewUrl?.split("/").pop() || "Document Preview"}
          </span>
        }
      >
        {docPreviewType === "image" ? (
          <img src={docPreviewUrl} alt="Clearance Document" style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }} />
        ) : docPreviewType === "pdf" ? (
          <iframe src={docPreviewUrl} title="Clearance PDF" style={{ width: "100%", height: "80vh", border: "none" }} />
        ) : null}
      </Modal>
    </div>
  );
});
const OrderBulkOperationsContainerComponent = withRouter((props) => {
  const warehouseFilter = useContext(WarehouseContext);
  const { orgSettings: organizationSettings, accountsExceeded, currentOrg } =
    useContext(OrgContext);
  return (
    <OrderBulkOperationContainer
      warehouseFilter={warehouseFilter}
      organizationSettings={organizationSettings}
      creditsExceededAccnts={accountsExceeded}
      currentOrg={currentOrg}
      {...props}
    />
  );
});
OrderBulkOperationsContainerComponent.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  resetOrders: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  handleMultipleOrdersStatusChange: PropTypes.func.isRequired,
  handleReceiveToConfirm: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
  refreshCallback: PropTypes.func.isRequired,
  enableLoading: PropTypes.func.isRequired
};
OrderBulkOperationsContainerComponent.defaultProps = {};
export default OrderBulkOperationsContainerComponent;